
  const config = {
    REACT_APP_ENVIRONMENT: "Local",
    REACT_APP_MICROSOFT_LOGIN_URL: "https://login.microsoftonline.com/",
    REACT_APP_AAD_CLIENT_ID: "29dc3823-3306-4537-aaa7-c70e0ca3f62f",
    REACT_APP_AZURE_TENANT_ID: "de0795e0-d7c0-4eeb-b9bb-bc94d8980d3b",
    REACT_APP_WEB_URL: "http://localhost:3000",
    REACT_APP_BASE_URL: "https://wiinterpretd-api.wistron.com",
    REACT_APP_SOCKET_SERVER: "wss://wiinterpretd-ws.wistron.com",
    REACT_APP_TRANSLATION_ENDPOINT: "wss://wiinterpret-dev-speech.cognitiveservices.azure.com/stt/speech/recognition/conversation/cognitiveservices/v1?language=",
    REACT_APP_SPEECH_ENDPOINT: "wss://wiinterpret-dev-speech.cognitiveservices.azure.com/tts/cognitiveservices/websocket/v1",
    // REACT_APP_FEEDBACK: "https://forms.office.com/Pages/ResponsePage.aspx?id=4JUH3sDX6065u7yU2JgNO1Erch1qo7VOo3v9z7isRfBURUVXNzBEN0dYNVczWTlEQktJRUcyUTVTNy4u",
    REACT_APP_TEXT_ENDPOINT: "https://wiinterpret-dev-translation.cognitiveservices.azure.com",
    REACT_APP_WEB_KEY: "wilnterpret520_CsBwWjR",
  };
  
  export default config;
  
